import React from 'react';
import PaymentCampaignContainer from '../../containers/step4_settings/PaymentCampaignContainer';

const StepFour = () => {
  return (
    <div className="campaingInfoCard customPanelStyleDisplays" style={{ padding: '24px' }}>
      <PaymentCampaignContainer />
    </div>
  );
};

export default StepFour;
